import { API_BASE_URL } from '../developer/constants';

export const geocoderAPIUrl = `${API_BASE_URL}/pwd/search`;
export const NO_RESULTS_MESSAGE =
    'Couldn\'t find an eligible parcel for that search';
export const NETWORK_ERROR_MESSAGE =
    'There was a problem with the network or our server';
export const CANCEL_REQUEST_MESSAGE = 'Canceled prior search request';
